import React, { useState, useEffect } from 'react';
import './PostPopUp.css';
import photoIcon from '../../images/image.png';
import videoIcon from '../../images/video.jpeg';
import attatchmentIcon from '../../images/attatchment.png';
import crossIcon from '../../images/cross.png';
import addMoreIcon from '../../images/addMore.png';
import userIcon from '../../images/user.png';
import postIcon from '../../images/post.png';
import next from '../../images/next.png';
import back from '../../images/back.png';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { queryUserFromUsername } from '../../../api/userRequest';
import _ from 'lodash';
import { BASE_URL } from '../../../api/config';

const PostPopUp = ({ onClose, setProgress, setReloadPost, reloadPost,userData }) => {
  // ------------- @ sign query
  const [signQuery, setSignQuery] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  // --------------------------
  const API = axios.create({ baseURL: BASE_URL });
  const [inputValue, setInputValue] = useState('');
  let [selectedFile, setSelectedFile] = useState([]);

  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
  let [selectedMedia, setSelectedMedia] = useState([]);

  const handleNextMedia = () => {
    setCurrentMediaIndex((prevIndex) =>
      prevIndex === selectedMedia.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePreviousMedia = () => {
    setCurrentMediaIndex((prevIndex) =>
      prevIndex === 0 ? selectedMedia.length - 1 : prevIndex - 1
    );
  };

  // Debounce the input change to avoid frequent API calls while typing
  const debouncedInputChange = React.useMemo(
  () =>
    _.debounce(async (newValue) => {
      const lastword = newValue.split(' ').pop();
      if (lastword.startsWith('@')) {
        try {
          const { data } = await queryUserFromUsername(lastword.slice(1));
          if (data.result) {
            setSignQuery(data.result);
            setShowSuggestions(true);
          }
        } catch (err) {
          toast.error(
            err?.response?.data?.message ||
            err?.message ||
            'User search failed'
          );
        }
      } else {
        setShowSuggestions(false);
      }
    }, 300),
  []
);

useEffect(() => {
  return () => debouncedInputChange.cancel();
}, [debouncedInputChange]);

  const handleInputChange = async (event) => {
    const newValue = event.target.value;
    setInputValue(newValue);
    debouncedInputChange(newValue);
  };

  const closePopUp = () => {
    onClose();
  };

  const creatingPost = async () => {
  if (!inputValue.trim() && selectedFile.length === 0) {
    toast.error("Post cannot be empty");
    return;
  }

  try {
    setProgress(20);

    const token = localStorage.getItem("skilloptoken");
    const config = {
      headers: {
        Authorization: token,
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    };

    let mediaUrls = [];

    // STEP 1: upload media first
    if (selectedFile.length > 0) {
      const mediaForm = new FormData();

      Array.from(selectedFile).forEach((file) => {
        mediaForm.append("media", file);
      });

      const mediaRes = await API.post(
        "/api/post/media",
        mediaForm,
        config
      );

      mediaUrls = mediaRes.data.result;
    }

    setProgress(60);

    // STEP 2: create post with URLs
    await API.post(
      "/api/post/create",
      {
        title: inputValue,
        imageUrls: mediaUrls,
      },
      {
        headers: { Authorization: token },
        withCredentials: true,
      }
    );

    setProgress(100);
    toast.success("Post created successfully");

    setReloadPost(!reloadPost);
    onClose();
  } catch (err) {
    toast.error(
      err?.response?.data?.message ||
      err?.message ||
      "Post creation failed"
    );
    setProgress(0);
  }
};


  const handleUpload = () => {
    document.querySelector('.photo-popup').style.display = 'flex';
  };

  const handleImageChange = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      const newSelectedFiles = [...selectedFile]; // Maintain an array of selected files
      const newMedia = [...selectedMedia];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();

        reader.onload = (event) => {
          const dataUrl = event.target.result;
          newMedia.push({ dataUrl, type: file.type });
          newSelectedFiles.push(file); // Add the selected file to the array
          setSelectedMedia(newMedia);
          setSelectedFile(newSelectedFiles); // Update the selectedFile state
        };

        reader.readAsDataURL(file);
      }
    }
  };

  function getFileType(mimeType) {
    if (mimeType.startsWith('image/')) {
      return 'image';
    } else if (mimeType.startsWith('video/')) {
      return 'video';
    } else if (mimeType.startsWith('audio/')) {
      return 'audio';
    } else {
      return 'unknown';
    }
  }

  const hideImgPopup = () => {
    document.querySelector('.photo-popup').style.display = 'none';
  };

  const handlePostThroughEnterKey = (e) => {
    if (e.keyCode === 13 && !e.shiftKey) {
      // creatingPost();
    }
  };

  const chooseFileBtn = React.createRef();

  return (
    <div className='postpopup-container' onClick={closePopUp}>
      <div className='popup-container' onClick={(e) => e.stopPropagation()}>
        <div className='popup-header'>
          <img
            height={40}
            width={40}
            src={userData?.profilePicUrl || userIcon}
            alt='user'
            className='popup-avatar'
          />
          <span className='popup-title'>Create Post</span>
          <button
            type='button'
            onClick={closePopUp}
            className='popup-close'
            aria-label='Close'
          >
            &times;
          </button>
        </div>

        <div className='writeSection'>
          <textarea
            value={inputValue}
            onKeyDown={handlePostThroughEnterKey}
            onChange={handleInputChange}
            type='text'
            className='writePost'
            rows={6}
            placeholder='What are you Thinking...?'
            autoFocus
          />
          {showSuggestions && (
            <div className='usernameList' id='usernameList'>
              {signQuery.slice(0, 7).map((user) => (
                <div
                  className='user'
                  key={user._id}
                  onClick={() => {
                    setInputValue(
                      inputValue.replace(/@\S+$/, `@${user.username} `)
                    );
                    setShowSuggestions(false);
                  }}
                >
                  <img
                    src={user.profilePicUrl || '/user.png'}
                    alt='profile-pic'
                    height={30}
                    width={30}
                    className='rounded-full'
                  />
                  <p>{user.username}</p>
                </div>
              ))}
            </div>
          )}
        </div>

        {selectedMedia.length > 0 && (
          <div className='mediaPreview image-preview'>
            {selectedMedia.length > 1 && (
              <button
                type='button'
                onClick={handlePreviousMedia}
                className='media-nav-btn media-nav-prev'
                aria-label='Previous'
              >
                <img height={22} width={22} src={back} alt='' />
              </button>
            )}
            <div className='mediaPreview-inner'>
              {getFileType(selectedMedia[currentMediaIndex].type) ===
              'image' ? (
                <img
                  src={selectedMedia[currentMediaIndex].dataUrl}
                  alt='selected-img'
                  className='cropped-image'
                />
              ) : getFileType(selectedMedia[currentMediaIndex].type) ===
                'video' ? (
                <video
                  muted
                  loop
                  autoPlay
                  className='cropped-image'
                  src={selectedMedia[currentMediaIndex].dataUrl}
                  alt='selected-video'
                />
              ) : getFileType(selectedMedia[currentMediaIndex].type) ===
                'unknown' ? (
                <iframe
                  src={selectedMedia[currentMediaIndex].dataUrl}
                  title='Document Preview'
                  width='100%'
                  height={270}
                  frameBorder='0'
                ></iframe>
              ) : getFileType(selectedMedia[currentMediaIndex].type) ===
                'audio' ? (
                <div
                  style={{
                    display: 'flex',
                    height: '270px',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <audio controls>
                    {' '}
                    <source
                      src={selectedMedia[currentMediaIndex].dataUrl}
                      title='Document Preview'
                      width='100%'
                      height={270}
                      frameBorder='0'
                    />
                  </audio>
                </div>
              ) : (
                <p>Unable to display preview...😵</p>
              )}
            </div>
            {selectedMedia.length > 1 && (
              <button
                type='button'
                onClick={handleNextMedia}
                className='media-nav-btn media-nav-next'
                aria-label='Next'
              >
                <img height={22} width={22} src={next} alt='' />
              </button>
            )}
          </div>
        )}

        <div className='photo-popup image-crop-container'>
          <input
            type='file'
            ref={chooseFileBtn}
            accept='image/*, video/*, .doc, .docx, .pdf, .txt, audio/*'
            name='postImages'
            multiple
            onChange={(e) => {
              setSelectedFile(e.target.files);
              handleImageChange(e);
            }}
            className='choose-file'
          />
          <button onClick={hideImgPopup} className='proceed'>
            Done
          </button>
        </div>

        <div className='uploadMedia'>
          <span onClick={handleUpload} className='upload'>
            <img height={20} width={20} src={photoIcon} alt='pic' />
            <label className='labels'>Photo</label>
          </span>
          <span onClick={handleUpload} className='upload'>
            <img height={20} width={26} src={videoIcon} alt='video' />
            <label className='labels'>Video</label>
          </span>
          <span onClick={handleUpload} className='upload'>
            <img
              height={20}
              width={20}
              src={attatchmentIcon}
              alt='attatchment'
            />
            <label className='labels'>Documents</label>
          </span>
          {selectedMedia.length >= 1 && (
            <span
              onClick={() => {
                handleUpload();
                chooseFileBtn.current.click();
              }}
              className='upload'
            >
              <img height={20} width={20} src={addMoreIcon} alt='Add more' />
              <label className='labels'>Add more</label>
            </span>
          )}
        </div>

        <div className='additionalOpt'>
          <button type='button' onClick={closePopUp} className='popup-cancel-btn'>
            <img height={18} width={18} src={crossIcon} alt='' />
            Cancel
          </button>
          <button type='button' onClick={creatingPost} className='popup-post-btn'>
            Post
            <img height={18} width={18} src={postIcon} alt='' />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PostPopUp;
